<template>
	<b-navbar toggleable :class="classes">

		<div :class="containerClasses">
			<slot name="brand" v-if="showBrand">
				<a href="http://dccllc.net" class="brand-mobile-display">
					<img
						alt="DCC logo"
						height="60"
						src="/img/brand/dcc_company.png"
						style="height: 60px !important"
				/></a>
			</slot>

			<slot name="toggle-button">
				<button
					class="navbar-toggler collapsed"
					v-if="hasMenu"
					type="button"
					@click="toggleMenu"
					aria-expanded="false"
					aria-label="Toggle navigation"
				>
					<span class="navbar-toggler-bar navbar-kebab"></span>
					<span class="navbar-toggler-bar navbar-kebab"></span>
					<span class="navbar-toggler-bar navbar-kebab"></span>
				</button>
			</slot>

			<b-navbar-toggle target="nav-text-collapse" @click.stop="toggleMenu"> </b-navbar-toggle>

			<b-collapse
				is-nav
				:id="showBrand?'nav-text-collapse-auth':'nav-text-collapse'"
				class="navbar-custom-collapse collapse show"
				:class="menuClasses"
				:visible="show"
				v-click-outside="closeMenu"
			>
				<slot :close-menu="closeMenu"></slot>
			</b-collapse>
		</div>
	</b-navbar>
</template>
<script>
import {mapGetters} from "vuex";
export default {
	name: "base-nav",
	props: {
		show: {
			type: Boolean,
			default: false,
			description: "Whether navbar menu is shown (valid for viewports < specified by `expand` prop)",
		},
		transparent: {
			type: Boolean,
			default: false,
			description: "Whether navbar is transparent",
		},
		expand: {
			type: String,
			default: "lg",
			description: "Breakpoint where nav should expand",
		},
		menuClasses: {
			type: [String, Object, Array],
			default: "",
			description: "Navbar menu (items) classes. Can be used to align menu items to the right/left",
		},
		containerClasses: {
			type: [String, Object, Array],
			default: "container",
			description:
				"Container classes. Can be used to control container classes (contains both navbar brand and menu items)",
		},
		type: {
			type: String,
			default: "",
			validator(value) {
				return [
					"",
					"dark",
					"success",
					"danger",
					"warning",
					"white",
					"primary",
					"light",
					"info",
					"vue",
				].includes(value);
			},
			description: "Navbar color type",
		},
	},
	model: {
		prop: "show",
		event: "change",
	},
	data() {
		return {
			showBrand: true
		}
	},
	computed: {
		...mapGetters(["isAuthenticated"]),
		classes() {
			let color = `bg-${this.type}`;
			let classes = [{"navbar-transparent": this.transparent}, {[`navbar-expand-${this.expand}`]: this.expand}];
			if (this.position) {
				classes.push(`navbar-${this.position}`);
			}
			if (!this.transparent) {
				classes.push(color);
			}
			return classes;
		},
		hasMenu() {
			return this.$slots.default;
		},
	},
	mounted() {
		if (this.isAuthenticated) {
			this.showBrand = false
		}
	},
	methods: {
		toggleMenu() {
			this.$emit("change", !this.show);
		},
		closeMenu() {
			this.$emit("change", false);
		},
	},
};
</script>
